// material-ui
import { useTheme } from '@mui/material/styles'
import logo from 'assets/images/Purcent-Logo-Color-W145.png'

import logoDark from 'assets/images/Purcent-Logo-LightColor-W145.png'
import { ThemeMode } from 'types/config'

// ==============================|| LOGO SVG ||============================== //

function LogoMain({ primary = true, reverse, ...others }: { primary?: boolean; reverse?: boolean }) {
  const theme = useTheme()
  const logoSrc = primary ? logo : logoDark
  return <img src={theme.palette.mode === ThemeMode.DARK ? logoDark : logoSrc} alt="Purcent" width="200" />
}

export default LogoMain
